import { render, staticRenderFns } from "./ManageTableColumns.vue?vue&type=template&id=295019ce"
import script from "./ManageTableColumns.vue?vue&type=script&lang=js"
export * from "./ManageTableColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports